import { useAction, useAtom } from "@reatom/npm-react";
import { ProductSourceDtoSourceEnum } from "definitions/product-storage";
import { useEffect, useMemo } from "react";
import {
  loadProductPrice,
  productPriceAtom,
} from "src/pages/ProductDetailPage/store/fetchers/getProductDetailWithPrice";
import { getActiveLimiterRequest } from "src/store/fetchers";

import { buildVariantsProduct } from "../utils";

export const useProductDetailWithPrice = (
  spuId: string | null | undefined,
  platform: ProductSourceDtoSourceEnum | null,
) => {
  const [activeLimiter] = useAtom(getActiveLimiterRequest.dataAtom);

  const [productDetail] = useAtom(productPriceAtom);
  const [isLoading] = useAtom(loadProductPrice.isLoadingAtom);
  const [loadError] = useAtom(loadProductPrice.errorAtom);

  const load = useAction(loadProductPrice);

  const hasSubscribeDetails = !!activeLimiter?.length;

  useEffect(() => {
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler -- загрузка цены по spuId/platform (data fetch)
    if (!spuId || !platform) return;
    if (!hasSubscribeDetails) return;

    load({ spuId, platform, force: false });
  }, [spuId, platform, hasSubscribeDetails, load]);

  const reload = () => {
    if (!spuId || !platform) return;
    load({ spuId, platform, force: true });
  };

  const variants = useMemo(() => {
    if (!productDetail || !platform) return null;
    return buildVariantsProduct(productDetail, platform);
  }, [productDetail, platform]);

  return {
    variants,
    isLoading,
    hasSubscribeDetails,
    hasLoadError: Boolean(loadError),
    reload,
  };
};
